module.exports = __webpack_public_path__ + "img/chev-right-dark.27ad3e9a.svg";